export const API_KEY_GET_FRODERS_LIST = "API_KEY_GET_FRODERS_LIST";
export const API_KEY_GET_FRODER = "API_KEY_GET_FRODER";
export const API_KEY_GET_PROJECTS_LIST = "API_KEY_GET_PROJECTS_LIST";
